import Vue from "vue";
import VueRouter from "vue-router";
import { isMobile } from "@/scripts/mobile";

// const ArtistMobile = () => import( '@/views/Artist/Mobile/Artist.vue');
// const ArtistDesktop = () => import( '@/views/Artist/Desktop/Artist.vue');
const Artist = () => import("@/views/Artist/Artist.vue");
// const ContactMobile = () => import( '@/views/Contact/Mobile/Contact.vue');
// const ContactDesktop = () => import( '@/views/Contact/Desktop/Contact.vue');
// const Contact = () => import("@/views/Contact/Contact.vue");
// const HomeMobile = () => import( '@/views/LP3/Mobile/LP3.vue');
// const HomeDesktop = () => import( '@/views/LP3/Desktop/LP3.vue');
const Home = () => import("@/views/LP3/LP3.vue");
// const MultimediaMobile = () => import( '@/views/Multimedia/Mobile/Multimedia.vue');
// const MultimediaDesktop = () => import( '@/views/Multimedia/Desktop/Multimedia.vue');
// const PolskiTopWszechMobile = () => import( '@/views/PolskiTopWszech/Mobile/PolskiTopWszech.vue');
// const PolskiTopWszechDesktop = () => import( '@/views/PolskiTopWszech/Desktop/PolskiTopWszech.vue');
const PolskiTopWszech = () =>
  import("@/views/PolskiTopWszech/PolskiTopWszech.vue");
// const SpecialNoteMobile = () => import( '@/views/SpecialNote/Mobile/SpecialNote.vue');
// const SpecialNoteDesktop = () => import( '@/views/SpecialNote/Desktop/SpecialNote.vue');
const SpecialNote = () => import("@/views/SpecialNote/SpecialNote.vue");
// const SongMobile = () => import( '@/views/Song/Mobile/Song.vue');
// const SongDesktop = () => import( '@/views/Song/Desktop/Song.vue');
const Song = () => import("@/views/Song/Song.vue");
// const TeamMobile = () => import( '@/views/Team/Mobile/Team.vue');
// const TeamDesktop = () => import( '@/views/Team/Desktop/Team.vue');
// const Team = () => import("@/views/Team/Team.vue");
const Multimedia = () => import("@/views/Multimedia/Multimedia.vue");
// const TopWszechMobile = () => import( '@/views/TopWszech/Mobile/TopWszech.vue');
// const TopWszechDesktop = () => import( '@/views/TopWszech/Desktop/TopWszech.vue');
const TopWszech = () => import("@/views/TopWszech/TopWszech.vue");
const ForgotPasswordDesktop = () =>
  import("@/views/ForgotPassword/Desktop/ForgotPassword.vue");
const ForgotPasswordMobile = () =>
  import("@/views/ForgotPassword/Mobile/ForgotPassword.vue");
const SearchResultsDesktop = () =>
  import("@/views/SearchResults/Desktop/SearchResults.vue");
const SearchResultsMobile = () =>
  import("@/views/SearchResults/Mobile/SearchResults.vue");
const ConfirmAccountDesktop = () =>
  import("@/views/ConfirmAccount/Desktop/ConfirmAccount.vue");
const ConfirmAccountMobile = () =>
  import("@/views/ConfirmAccount/Mobile/ConfirmAccount.vue");

const chooseElement = (mobile, desktop) => {
  return isMobile() ? mobile : desktop;
};

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    // {
    //   path: '/artysta/:id',
    //   component: chooseElement(ArtistMobile, ArtistDesktop),
    //   name: 'artysta',
    // },
    {
      path: "/artysta/:id",
      component: Artist,
      name: "artysta",
    },
    // {
    //   path: "/kontakt",
    //   component: Contact,
    //   name: "kontakt",
    // },
    {
      path: "",
      component: Home,
      name: "home",
    },
    {
      path: "/lp3/:id",
      component: Home,
      name: "homeOfId",
    },
    // {
    //   path: '/multimedia',
    //   component: chooseElement(MultimediaMobile, MultimediaDesktop),
    //   name: 'multimedia',
    // },
    {
      path: "/polskitopwszechczasow",
      component: PolskiTopWszech,
      name: "polskitopwszechczasow",
    },
    {
      path: "/polskitopwszechczasow/:id",
      component: PolskiTopWszech,
      name: "polskitopwszechczasowID",
    },

    {
      path: "/wyszukaj",
      component: chooseElement(SearchResultsMobile, SearchResultsDesktop),
      name: "wyszukaj",
    },
    {
      path: "/utwór/:id",
      component: Song,
      name: "utwór",
    },
    {
      path: "/topspecjalny/:top",
      component: SpecialNote,
      name: "topspecjalny",
    },

    {
      path: "/topwszechczasow",
      component: TopWszech,
      name: "topwszechczasow",
    },
    {
      path: "/topwszechczasow/:id",
      component: TopWszech,
      name: "topwszechczasowID",
    },
    // {
    //   path: '/zespol',
    //   component: Team,
    //   name: 'zespol',
    // },
    {
      path: "/multimedia",
      component: Multimedia,
      name: "multimedia",
    },
    {
      path: "/resethasla/:name",
      component: chooseElement(ForgotPasswordMobile, ForgotPasswordDesktop),
      name: "resethasla",
    },
    {
      path: "/potwierdzkonto/:name",
      component: chooseElement(ConfirmAccountMobile, ConfirmAccountDesktop),
      name: "potwierdzkonto",
    },
  ],
});

export default router;
